


















































































































import { Component, Watch } from 'vue-property-decorator';
import { default as format } from 'date-fns/format';
import $ from 'jquery';
import reportModule from '@/store/modules/common/report.module';
import Mixin from '@/mixin';
import VDateTimeDuring from './VDateTimeDuring.vue';
import { Coach, CoachClient, CoachClientCompanyOptions, CoachClientOptions } from '@/store/models';
import coachService from '@/services/common/coach.service';
import _ from 'lodash';
import reportViewModel from '@/views/mastercoach/reportViewModel';

const FILTER_COACH_CLIENT_ID = 'FILTER_COACH_CLIENT_ID';
const REPORT_SORTING = 'REPORT_SORTING';

@Component({
  name: 'VHeaderIndividualItem',
  components: { VDateTimeDuring },
})

export default class VHeaderIndividualItem extends Mixin {
  public reportSorting: 'updated' | 'created' | 'goalId' = window.localStorage.getItem(REPORT_SORTING) as 'updated' | 'created' | 'goalId' || 'goalId';
  public reportCoachClientId = window.localStorage.getItem(FILTER_COACH_CLIENT_ID) || '';
  public isEdit = false;
  public individuals: Coach[] = [];
  public coachId: string = '';
  public companies: string[] = [];
  public company: string = '';
  public individualMap: Map<string, Coach[]> = new Map();
  public reportIndividualData: any = null;
  public coachClients: CoachClient[] = [];
  public clientOptions: CoachClientOptions[] = [];
  public companyOptions: CoachClientCompanyOptions[] = [];
  public reportCoachClientCompany = '';

  @Watch('reportCoachClientId', { deep: false, immediate: true })
  async updateReportCoachClientId() {
    await reportModule.updateReportCoachClientId(this.reportCoachClientId);
    window.localStorage.setItem(FILTER_COACH_CLIENT_ID, this.reportCoachClientId)
  }

  @Watch('reportCoachClientCompany', { deep: false, immediate: true })
  async updateReportCoachClientCompany() {
    await reportModule.updateReportCoachClientCompanyName(this.reportCoachClientCompany);
    const report = this.companyOptions.find(company => company.id === this.reportCoachClientCompany);
    await reportModule.updateReportCoachClientType(report?.type || null);
  }

  @Watch('reportSorting', { deep: false, immediate: true })
  async updateReportSorting() {
    await reportModule.updateReportSorting(this.reportSorting);
    window.localStorage.setItem(REPORT_SORTING, this.reportSorting)
  }

  @Watch('coachId', { deep: false, immediate: true })
  updateCoachId() {
    this.handleReport();
    this.loadCoachClients();
    reportViewModel.coachId = this.coachId
  }

  get options() {
    return this.clientOptions;
  }

  get score() {
    if (!this.reportIndividualData) return 0;
    return this.reportIndividualData['coachingSuccessIndex(CSI)Score'];
  }

  get name() {
    return `${this.reportIndividualData.coachFirstName} ${this.reportIndividualData.coachLastName}`
  }

  public async handleCompanyChange() {
    this.reportCoachClientId = '';
  }

  public async handleClientChange(e) {
    this.reportCoachClientCompany = '';
  }

  public async loadCoachClients() {
    if (!this.coachId) return;
    const data = await coachService.loadCoachClients({
      coachId: this.coachId,
    })
    /**
     * Client Dropdown Options
    */
    this.clientOptions = data.map((client: CoachClient) => {
      const { id, firstName, lastName } = client;
      return ({
        id: String(id),
        name: firstName + ' ' + lastName
      })
    })
    /**
     * Company / Department Dropdown Options
    */
    this.getCompanyOptions(data);

    /** 
     * Reset state
    */
    if (this.reportCoachClientCompany) {
      this.reportCoachClientCompany = '';
    }

    if (this.reportCoachClientId) {
      this.reportCoachClientId = '';
    }
    
    if (this.reportCoachClientId === '' && this.clientOptions.length > 0) {
      this.reportCoachClientId = this.clientOptions[0].id || '';
    }
  }

  public async loadIndividuals() {
    if (this.individualMap && this.individualMap.get(reportViewModel.company)?.length || -1 > 0) {
      this.individuals = [...this.individualMap.get(reportViewModel.company)];
    } else {
      const _individuals = [
        ...(await coachService.loadCoachByCompany({
          companyName: this.company
        }))
      ];
      this.individualMap.set(reportViewModel.company, _individuals);
      this.individuals = [...this.individualMap.get(reportViewModel.company)];
    }
  }

  public handleToggle() {
    this.isEdit = !this.isEdit;
  }

  public handleReport() {
    this.isEdit = false;
    reportModule
      .loadIndividualReport({
        fromDate: window.sessionStorage.getItem('REPORT_FROM_DATE') ?? reportViewModel.startDate,
        toDate: window.sessionStorage.getItem('REPORT_TO_DATE') ?? reportViewModel.endDate,
        coachId: this.coachId,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
      .then(
        () => {
          this.reportIndividualData = reportModule.reportIndividualData
        }
      );
  }

  public formatDate() {
    const fromDate = window.sessionStorage.getItem('REPORT_FROM_DATE') ?? reportViewModel.startDate;
    const toDate = window.sessionStorage.getItem('REPORT_TO_DATE') ?? reportViewModel.endDate;
    const from = new Date(fromDate as string);
    const to = new Date(toDate as string);
    return `${format(from, 'yyyy-MM-dd')} to ${format(to, 'yyyy-MM-dd')}`;
  }

  public async print(e) {
    $('.v-top-nav').hide(0);
    $('.c-menu').hide(0);
    $('.margin_container').css('margin-left','0rem');
    $('.c_table__body').css('overflow-y','hidden');
    $('.c_table__body').css('max-height','none');
    $('#chart_content').css('overflow-y','hidden');
    $('#chart_content').css('max-height','none');
    $('.no-print').css('display','none');
    await window.print();
    $('.v-top-nav').show(0);
    $('.c-menu').show(0);
    $('.margin_container').css('margin-left','8rem');
    $('.c_table__body').css('overflow-y','auto')
    $('.c_table__body').css('max-height','70vh');
    $('#chart_content').css('overflow-y','auto');
    $('#chart_content').css('max-height','70vh');
    $('.no-print').css('display','block');
  }

  public goalView() {
    if (this.reportCoachClientId) {
      this.goTo(`/goal-list?coachId=${this.coachId}&coachClientId=${this.reportCoachClientId}`)
    }
  }

  public goalsView() {
    if (this.reportCoachClientCompany) {
      const report = this.companyOptions.find(company => company.id === this.reportCoachClientCompany)
      if (report) {
        this.goTo(`/goal-list?coachId=${this.coachId}&${report.type}=${report.id}`)
      }
    }
  }

  public getCompanyOptions(data: any) {
    const groupOptions: CoachClientCompanyOptions[] = [];
    const filterData = _.chain(data)
      .map(client => {
        return {
          id: client['id'],
          companyName: client['companyName'],
          department: client['department'],
        };
      })
      .filter(client => (client.companyName || client.department))
      .orderBy(['companyName'], ['asc'])
      .groupBy('companyName')
      .toPairs()
      .value()

    _.map(filterData, groupCompany => {
      const companyName = groupCompany[0];
      const departmentList = groupCompany[1];

      if (companyName && !groupOptions.find(option => option.id === companyName)) {
        groupOptions.push({
          id: companyName,
          name: companyName,
          type: 'coachClientCompanyName',
        })
      }
      
      departmentList
        .filter(({ department: departmentName }) => departmentName)
        .sort((a: any, b: any) => {
          const textA = a.department.toUpperCase();
          const textB = b.department.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
        .map(({ department: departmentName }) => {
          if (departmentName && !groupOptions.find(option => option.id === departmentName)) {
            groupOptions.push({
              id: departmentName,
              name: departmentName,
              type: 'coachClientDepartment',
            })
          }
      })
    })
    this.companyOptions = groupOptions;
  }

  mounted() {
    reportViewModel.loadReportParams();
    this.coachId = reportViewModel.coachId
    this.company = reportViewModel.company

    this.loadIndividuals();
    this.handleReport();
    this.loadCoachClients();
  }
}
